import Repository from "./Repository";

const ApplicationLog = "getapplicationlog";
const ERROR_LOG="errorlog"


export default {
  ApplicationLog(payload) {
    return Repository.post(transformRoute(ApplicationLog),payload);
  },
  ErrorLOG(payload){
    return Repository.post(transformRoute(ERROR_LOG),payload)
  }

};

const transformRoute = (route) => {
  return `/auth/${route}`;
};
